import { type ThemeParser } from '../../../core/theme';
import { util } from 'echarts/core';
import { normalizeToArray } from '../../../util/utils';

function getLevelOption() {
  return [
    {
      itemStyle: {
        borderColor: '#fff',
        borderWidth: 0,
        gapWidth: 2,
      },
      upperLabel: {
        show: false,
      },
    },
    {
      itemStyle: {
        borderColor: '#e0e2e5',
        borderWidth: 4,
        gapWidth: 4,
      },
      emphasis: {
        itemStyle: {
          borderColor: '#BCBCBC',
        },
      },
      upperLabel: {
        show: true,
        color: 'rgba(0, 0, 0, 0.84)',
        fontWeight: 700,
        formatter: (params) => {
          return `{name|${params.name}}{${params.data.isOpen ? 'close' : 'open'}|}`;
        },
        rich: {
          name: {
            lineHeight: 22,
            padding: [2, 0, 0, 0],
          },
          close: {
            width: 16,
            height: 16,
            backgroundColor: {
              image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEzNDBfMTkwNjkpIj4KPHBhdGggZD0iTTEzIDJDMTMuNTUyMyAyIDE0IDIuNDQ3NzIgMTQgM1YxM0MxNCAxMy41NTIzIDEzLjU1MjMgMTQgMTMgMTRIM0MyLjQ0NzcyIDE0IDIgMTMuNTUyMyAyIDEzVjNDMiAyLjQ0NzcyIDIuNDQ3NzIgMiAzIDJIMTNaTTEzIDNIM1YxM0gxM1YzWk0xMiA5VjEwSDEwVjEySDlWOUgxMlpNNyA0VjdINFY2SDZWNEg3WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC44NCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEzNDBfMTkwNjkiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=='
            },
            align: 'right',
          },
          open: {
            width: 16,
            height: 16,
            backgroundColor: {
              image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDVWN0gxMlY0SDlWNUgxMVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuODQiLz4KPHBhdGggZD0iTTUgMTFWOUg0VjEySDdWMTFINVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuODQiLz4KPHBhdGggZD0iTTEzIDJDMTMuNTUyMyAyIDE0IDIuNDQ3NzIgMTQgM1YxM0MxNCAxMy41NTIzIDEzLjU1MjMgMTQgMTMgMTRIM0MyLjQ0NzcyIDE0IDIgMTMuNTUyMyAyIDEzVjNDMiAyLjQ0NzcyIDIuNDQ3NzIgMiAzIDJIMTNaTTEzIDNIM1YxM0gxM1YzWiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC44NCIvPgo8L3N2Zz4K'
            },
            align: 'right',
          },
        },
      },
    },
    {
      itemStyle: {
        borderWidth: 0,
        gapWidth: 1,
        borderColor: '#f5f5f5',
        backgroundColor: '#f5f5f5',
        color: '#f5f5f5',
      },
      upperLabel: {
        show: true,
        borderColor: '#009',
        color: '#fff',
        formatter: (params) => {
          return `{name|  ${params.name}}{${params.data.isOpen ? 'close' : 'open'}|}{space|}\n{hr|}`;
        },
        rich: {
          name: {
            lineHeight: 22,
            verticalAlign: 'middle',
            padding: [2, 0, 0, 0],
          },
          close: {
            width: 16,
            height: 16,
            backgroundColor: {
              image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEzNjFfMTQ2NTkpIj4KPHBhdGggZD0iTTEzIDJDMTMuNTUyMyAyIDE0IDIuNDQ3NzIgMTQgM1YxM0MxNCAxMy41NTIzIDEzLjU1MjMgMTQgMTMgMTRIM0MyLjQ0NzcyIDE0IDIgMTMuNTUyMyAyIDEzVjNDMiAyLjQ0NzcyIDIuNDQ3NzIgMiAzIDJIMTNaTTEzIDNIM1YxM0gxM1YzWk0xMiA5VjEwSDEwVjEySDlWOUgxMlpNNyA0VjdINFY2SDZWNEg3WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC44NCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEzNjFfMTQ2NTkiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=='
            },
            align: 'right',
          },
          open: {
            width: 16,
            height: 16,
            backgroundColor: {
              image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExIDVWN0gxMlY0SDlWNUgxMVoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuODQiLz4KPHBhdGggZD0iTTUgMTFWOUg0VjEySDdWMTFINVoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuODQiLz4KPHBhdGggZD0iTTEzIDJDMTMuNTUyMyAyIDE0IDIuNDQ3NzIgMTQgM1YxM0MxNCAxMy41NTIzIDEzLjU1MjMgMTQgMTMgMTRIM0MyLjQ0NzcyIDE0IDIgMTMuNTUyMyAyIDEzVjNDMiAyLjQ0NzcyIDIuNDQ3NzIgMiAzIDJIMTNaTTEzIDNIM1YxM0gxM1YzWiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC44NCIvPgo8L3N2Zz4K'
            },
            align: 'right',
          },
          space: {
            width: 4,
            align: 'right',
          },
          hr: {
            borderColor: '#f5f5f5',
            width: '100%',
            borderWidth: 1,
            height: 0,
          },
        }
      }
    }
  ];
}

function parseTreemap(option: Parameters<ThemeParser>[0]) {
  option.series = option.series.map(item => {
    if (item.type !== 'treemap') {
      return item;
    }
    return util.merge(
      {
        type: 'treemap',
        width: '100%',
        height: '100%',
        zoomToNodeRatio: 1,
        label: {
          padding: 4,
          show: true,
          width: '100%',
          formatter: (params) => {
            return `{name|${params.name}}\n{value|${params.data.labelValue}}`;
          },
          overflow: 'none',
          rich: {
            name: {
              align: 'center',
              color: '#fff',
              fontSize: 18,
              dvMinFontSize: 12,
              dvLineHeight: 1.3,
            },
            value: {
              align: 'center',
              color: '#fff',
              fontSize: 14,
              dvMinFontSize: 12,
              dvLineHeight: 1.3,
              dvValueFontDeviation: 3, // 处理名称字号校准
            },
          },
        },
        dvLabelShowTimer: 50,
        dvLabelType: 'twoLineCenter',
        breadcrumb: {
          show: false,
        },
        roam: false,
        nodeClick: false,
        upperLabel: {
          show: true,
          height: 22,
          fontSize: 12,
        },
        itemStyle: {
          borderColor: '#fff',
        },
        levels: getLevelOption(),
      },
      item,
      true
    );
  });
}


/**
 * 移动端主题-矩形树图解析器
 */
export function treemapThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  const series = normalizeToArray(option.series);
  if (series.find(i => i.type === 'treemap')) {
    parseTreemap(option);
  }
}
